// Pre-roll before playback drops in: a pure delay, advanced by the RAF frame delta (the
// caller passes dt × tempo, so this never becomes a second clock — single-clock invariant).
// It does not click: the practice pulse is already running and clicks straight through the
// pre-roll, which is exactly what keeps the beat unbroken across the drop-in. The delay is
// the caller's beat alignment plus any count-in beats (see `beat-sync.ts`).

export class CountIn {
  private left: number | null = null; // music-seconds remaining; null = disarmed

  get active(): boolean {
    return this.left !== null;
  }

  /** Arm a pre-roll of `delaySeconds` (music-seconds). Returns true so the caller can
   *  branch on "a pre-roll started" (leave the engine paused). */
  start(delaySeconds: number): boolean {
    this.left = Math.max(0, delaySeconds);
    return true;
  }

  cancel(): void {
    this.left = null;
  }

  /** Advance by one frame's worth of music time (`dt × tempo`). Returns true on the single
   *  frame the pre-roll completes. */
  tick(musicDt: number): boolean {
    if (this.left === null) return false;
    this.left -= musicDt;
    if (this.left <= 0) {
      this.left = null;
      return true;
    }
    return false;
  }
}
